import { render } from "./Wrapper.vue?vue&type=template&id=2e18c36c&scoped=true&ts=true"
import script from "./Wrapper.vue?vue&type=script&lang=ts"
export * from "./Wrapper.vue?vue&type=script&lang=ts"

import "./Wrapper.vue?vue&type=style&index=0&id=2e18c36c&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e18c36c"]])

export default __exports__